import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { initialize as initializeTracker } from '@pedidosya/web-native-bridges/tracker';
import { initialize as initializeFWF } from '../../external-libs/fwf';
import { logError } from '../utils/sentry';
import getFlagsBySelector from '../utils/fwf/getFlagsBySelector';
import updateFlags from '../redux/actions/fwf/updateFlags';
import Flags from '../models/Flags';

// Flags by redux selectors to updated
const FLAGS_SELECTORS = [];

/**
 * Init the tracker lib for WebView
 * @param {object} config
 */
async function initTracker(config) {
  try {
    await initializeTracker(config);
  } catch (error) {
    logError('[TRACKER][INIT]', error);
  }
}

/**
 * Init the funWithFlags lib for WebView + retrieve flags by selector
 * @param {object} config
 */
async function initFunWithFlags(config) {
  try {
    const { platform, ...configFWF } = config || {};

    await initializeFWF(configFWF);

    const flags = await getFlagsBySelector(FLAGS_SELECTORS, platform);

    return Flags(flags);
  } catch (error) {
    logError('[FWF][INIT]', error);
    return {};
  }
}

/**
 * Hook to initialize "FunWithFlags" and "Tracker"
 * @param {object} fwfConfig
 * @param {object} trackerConfig
 */
function useInitLibsNative(fwfConfig, trackerConfig) {
  const dispatch = useDispatch();

  useEffect(() => {
    initTracker(trackerConfig);

    initFunWithFlags(fwfConfig).then((flags) => {
      dispatch(updateFlags(flags));
    });
  }, [dispatch, fwfConfig, trackerConfig]);
}

export default useInitLibsNative;
